import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createDelegationInvitation } from "../../api/delegation";
import { CreateDelegationInvitationModel } from "../../interfaces/delegation";
import { delegationQueryKeys } from "./delegationQueryKeys";

export const useCreateDelegationInvitation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (model: CreateDelegationInvitationModel) =>
      createDelegationInvitation(model),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: delegationQueryKeys.invitations,
      });
    },
  });
};
